import { Container } from "@mui/system";
import { Grid, Paper, Typography, IconButton } from '@mui/material';
import RedButton from "../components/redButton";
import DeleteIcon from '@mui/icons-material/Delete';
import globals from "../globals";
import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import LoadingPage from "../error_page/loadingPage";

const course = [
    {
        title: 'Име на курс',
        student_name: 'Име на ученик',
        zoom_title: ' Заглавие на урока',
        date: '24.09.2025',
        time: '19:30'
    },
    {
        title: 'Име на курс',
        student_name: 'Име на ученик',
        zoom_title: ' Заглавие на урока',
        date: '24.09.2025',
        time: '19:30'
    },
    {
        title: 'Име на курс',
        student_name: 'Име на ученик',
        zoom_title: ' Заглавие на урока',
        date: '24.09.2025',
        time: '19:30'
    },
]

const UploadMeetingsPage = () => {
    const { token, user } = useAuth();
    const [meetings, setMeetings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${globals.apiUrl}/courses/meetings/upcoming-meetings`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data)
                setMeetings(data);
                setLoading(false);
            });
    }, []);

    const handleDeleteMeeting = (meetingId) => {
        fetch(`${globals.apiUrl}/courses/meetings/${meetingId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setMeetings(meetings.filter(meeting => meeting.id !== meetingId));
            });
    }

    return (
        loading ? (
            <LoadingPage />
        ) : (
            <Container>
                <Grid container>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 25, fontWeight: 'bold', mb: 3 }}>Предстоящи Zoom срещи</Typography>
                </Grid>
                <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                    {meetings <= 0 ? <Typography sx={{ color: globals.colors.textColor, fontWeight: 'bold' }}>Няма предстоящи Zoom срещи.</Typography> :
                        <Grid container spacing={5}>
                            {meetings.map(meeting =>
                                <Grid item>
                                    <Grid container spacing={1} alignItems={'center'} justifyContent={'end'}>
                                        <Grid item xs={12} sm={9}>
                                            <Typography>{meeting.course_title} / {meeting.student_name} / {meeting.zoom_title} / {new Date(meeting.date).toLocaleDateString('bg-BG')} / {new Date(meeting.date).toLocaleTimeString('bg-BG')}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={2}>
                                            <RedButton href={meeting.zoom_link} text={(user.role === 'student') ? 'Към срещата' : 'Започни срещата'} />
                                        </Grid>
                                        {user.role === 'instructor' || user.role === 'admin' && <Grid item xs={6} sm={1}>
                                            <IconButton onClick={() => handleDeleteMeeting(meeting.id)}><DeleteIcon /></IconButton>
                                        </Grid>}
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>}
                </Paper>
            </Container>
        )
    );
}

export default UploadMeetingsPage;